import { render, staticRenderFns } from "./kegiatanDetile.vue?vue&type=template&id=35c57233&"
import script from "./kegiatanDetile.vue?vue&type=script&lang=js&"
export * from "./kegiatanDetile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports